import React, { useState, useEffect } from "react";
import "../i18n/config";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import apiService from "../services/api.service";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import CustomerReqTableComponent from "./CustomerReqTable";
import OrdersTable from "./MyAccountComponents/OrdersTable";
import UserPersonalDetailsForm from "./UserPersonalDetailsForm";
import { useDispatch, useSelector } from "react-redux";
import { setCompany, setCompanyUser, setWorkers } from "../Redux/companyReducer";
import { Fragment } from "react";
import { setUser } from "../Redux/userReducer";
import { useTranslation } from "../hooks/useTranslation";
import CompanyWorkersTable from "./CompanyComponents/CompanyWorkersTable";
import CompanyGreetingsTable from "./CompanyComponents/CompanyGreetingsTable";
import CompanyDetailsForm from "./CompanyComponents/CompanyDetailsForm";
import { showToast, hideToast } from "../Redux/toastReducer";
import Snackbar from "@mui/material/Snackbar";
import ToastItem from "./MyAccountComponents/ToastItem";

function MyAccountComponent() {

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });
  // second useForm for the contact form
  const {
    register: registerContact,
    handleSubmit: handleSubmitContact,
    setValue: setValueContact,
    formState: { errors: errorsContact },
  } = useForm({ 
    mode: "onChange", 
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });

  const dispatch = useDispatch()
  const [lang, setLang] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const history = useHistory();
  const [thisAccountCustomer, setThisAccountCustomer] = useState(null);
  const [allCustomerRequests, setallCustomerRequests] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const TextAreaMaxLength = t("GiftTextAreaMaxLength");
  const companyUser = useSelector((state) => state.company.companyUser)
  const company = useSelector((state) => state.company.company)
  const loggedUser = useSelector((state) => state.user.user)
  const toasts = useSelector((state) => state.toast.toasts)
  const [activeSection, setActiveSection] = useState("ordersTab")

  const isCompanyUser = !!(companyUser && company);

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");

    if (loggedUser) {
      findCustomer(loggedUser.email, loggedUser.id);
    }
    else {
      logout();
    }


  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  useEffect(() => {
    if (thisAccountCustomer) { getAllCustomerRequests(thisAccountCustomer.customerId, chainId); }

  }, []);

  const findCustomer = (email, customerId) => {
    if( !(company && companyUser) ){
      apiService.getCustomer(email).then(
        (response) => {

          if (response.data.data && response.data.data.length > 0) {
            const customer = response.data.data.find((c) => c.customerId == customerId)
            if (!customer) {
              logout()
            } else {
              if (customerId != customer.customerId) {
                logout();
              } else {
                setThisAccountCustomer(response.data.data[response.data.data.length - 1]);
                if (company && companyUser) {
                  dispatch(setCompanyUser(response.data.data[response.data.data.length - 1]))
                }
              }
            }
          }
          else {
            logout();
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    }
    else{
      setThisAccountCustomer(companyUser);
    }


  }

  const logout = () => {
    dispatch(setUser(null))
    //dispatch(setThisAccountCustomer(null))
    if (company && companyUser) {
      dispatch(setCompanyUser(null))
      dispatch(setCompany(null))
      dispatch(setWorkers([]))
      history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang") || "eng"}`);
    } else {
      history.push(`/login?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang") || "eng"}`);
    }
  }

  const gotoProductspage = () => {
    history.push(`/?chainid=${chainId}&lang=${lang}`);
  }

  const showSection = (section) => {
    if(section === "GoToProductsPage"){
        gotoProductspage();
        return;
    }


    var myAccountSections = [];
    myAccountSections = document.getElementsByClassName("account-section");
    for (let index = 0; index < myAccountSections.length; index++) {
      const element = myAccountSections[index];
      element.classList.remove("hidden");
      element.classList.add("hidden");
    }

    document.getElementById(section)?.classList.remove("hidden");
    document.getElementById(section)?.classList.add("active");
    setActiveSection(section);

    switch (section) {
      case "personalDtlTab":
        fillInAllFields();
        break;
      case "ordersTab":
        break;
      case "contactformTab":
        fillInAllFields();
        getAllCustomerRequests(thisAccountCustomer.customerId, chainId);
        break;

      default:
        break;
    }
  }


  const clearText = (id) => {
    document.getElementById(id).value = "";
    var countfield = document.getElementById("counter");
    countfield.innerHTML = "0/" + TextAreaMaxLength;
  };

  const textCounter = (field, field2, maxlimit) => {
    var countfield = document.getElementById(field2);
    var textarea = document.getElementById(field);
    if (textarea.value.length > maxlimit) {
      textarea.value = textarea.value.substring(0, maxlimit);
      return false;
    }
    else {
      countfield.innerHTML = textarea.value.length + "/" + maxlimit;
    }
  }
  const getAllCustomerRequests = (mycustomerId, mychainId) => {

    if (mycustomerId && mycustomerId > 0) {
      apiService.getCustomerRequests(mycustomerId, mychainId).then(
        (response) => {
          if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0) {
            let allCustomerRequests = response.data.data;

            setallCustomerRequests(allCustomerRequests);
          }
          else {
            setallCustomerRequests([]);
          }

        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    }
  }

  const submitForm = (data) => {

    let valid = true;
    let errorMsg = "";

    if (!valid) {
      errorMsg = t("CheckAllFields");
      alert(errorMsg);
    }
    else {
      updateCustomerDetails(thisAccountCustomer.customerId, data.fullNameInput, data.EmailInput, data.PhoneInput, data);
    }
  };

  const submitContactForm = (data) => {

    let valid = true;
    let errorMsg = "";

    if (!valid || data.MessageContactInput === "") {
      errorMsg = t("CheckAllFields");
      alert(errorMsg);
      setErrorMessage(errorMsg);
      setTimeout(() => {
        setErrorMessage("");
      }, 4000);

    }
    else {
      if (data.MessageContactInput) {
        saveCustomerRequest(data.fullNameContactInput, data.EmailContactInput, data.PhoneContactInput, data.MessageContactInput);
        getAllCustomerRequests(thisAccountCustomer.customerId, chainId);
      }
    }
  };

  const fillInAllFields = () => {
    const fullname = `${thisAccountCustomer.customerFirstName} ${thisAccountCustomer.customerLastName}`;
    const email = thisAccountCustomer.customerEmail;
    const phone = thisAccountCustomer.customerPhone;
    const passport = thisAccountCustomer.customerIdentification;

    //user details fields
    setValue("fullNameInput", fullname, { shouldDirty: true });
    setValue("PhoneInput", phone, { shouldDirty: true });
    setValue("EmailInput", email, { shouldDirty: true });
    setValue("PassportInput", passport, { shouldDirty: true });

    //contact fields
    setValue("fullNameContactInput", fullname, { shouldDirty: true });
    setValue("PhoneContactInput", phone, { shouldDirty: true });
    setValue("EmailContactInput", email, { shouldDirty: true });

  };

  const updateCustomerDetails = (customerId, fullname, email, phone, data) => {
    //user details update
    apiService
      .updateCustomer(customerId, fullname, email, phone)
      .then((res) => {
        if (res) {
          dispatch(setUser(null))
          let loggedUser =
          {
            id: customerId,
            email: email
          }
          dispatch(setUser(loggedUser))
          dispatch(showToast({ message: t("CustomerDetailsUpdateSuccess"), severity: "success" }));
          findCustomer(email, loggedUser.id, false)
        }
        else {
          dispatch(showToast({ message: t("CustomerDetailsUpdateFailure"), severity: "error" }));
        }
      })
      .catch((err) => {
        console.error(err);
      });

      //comapny user, company details update
      if(isCompanyUser){
        
            apiService
            .setCompany({companyId: company.companyId, companyName: data.CompanyVatNumberInput, companyVatNumber: data.CompanyVatNumberInput})
            .then((res) => {
              if (res.data && !res.HasErrors) {
                dispatch(setCompany({
                  ...company,
                  companyName: data.CompanyNameInput,
                  companyVatNumber: data.CompanyVatNumberInput
                }))
                dispatch(showToast({ message: t("CustomerDetailsUpdateSuccess"), severity: "success" }));
              }
              else {
                dispatch(showToast({ message: t("CustomerDetailsUpdateFailure"), severity: "error" }));
              }
            })
            .catch((err) => {
              console.error(err);
            });
      }
  };


  const saveCustomerRequest = (fullname, email, phone, message) => {
    apiService
      .insertContactFormReq(fullname, phone, email, message, chainId, thisAccountCustomer.customerId)
      .then((res) => {
        if (res) {
          dispatch(showToast({ message: t("CustomerReqSendSuccess"), severity: "success" }));
        }
        else {
          dispatch(showToast({ message: t("CustomerReqSendFailure"), severity: "error" }));
        }
      })
      .catch((err) => {
        console.error(err);
      });

  };

  const renderMenuItems = () => {

    const menuItemsCustomer = [
      { label: "Orders", section: "ordersTab" },  //label - translation label, section - id of section to show
      { label: "PersonalDetails", section: "personalDtlTab" },
      { label: "ContactForm", section: "contactformTab" },
      { label: "GoToProductsPage", section: "GoToProductsPage" }
    ];

    const menuItemsCompany = [
      { label: "MyVouchers", section: "ordersTab", },
      { label: "CompanyDetails", section: "companyDtlTab" },
      { label: "WorkersList", section: "workersTab" },
      { label: "MyGreetings", section: "greetingsTab" },
      { label: "BackToProductsList", section: "GoToProductsPage" }
    ];

    let menuItems = isCompanyUser ? menuItemsCompany : menuItemsCustomer;

    return menuItems.map(item => (
        <button key={item.section || item.label} aria-label={t(item.label)}
          className={`side-menu-item box ${item.section && activeSection === item.section ? " active" : ""}`} onClick={() => showSection(item.section)} >
          {t(item.label)}
        </button>
      ));
  };

  return (
    <>
    <button onClick={gotoProductspage} className="bg-white border-0" ><img src="../images/logo-account.svg" alt="" className="logo-account" /></button>
      <div className={`my-account-wrap ${loggedUser ? 'logged-user' : ''}`}>
        <h3 aria-label={t("MyAccount")}>{t("MyAccount")}</h3>
        <Row className="my-account-content-wrap"> 

          {/* Header & Menu */}
          <Col lg="3">            
            {isCompanyUser ?
              <div className="company-logged-user">
                  { 
                    company && company.companyLogoUrl ? 
                    <img className='company-logo' src={company.companyLogoUrl}></img> 
                    : <span className="greeting_txt"></span>
                  }
                  <span className="greeting" role="application" aria-roledescription={t("Greeting")}
                    aria-label={(t("Hello") + " " + companyUser.customerFirstName + " " + companyUser.customerLastName + ",")}>
                    {(t("Hello") + " " + companyUser.customerFirstName + " " + companyUser.customerLastName + ",")}</span> 
                  <button aria-label={t("Logout")} role="button" className="company-logout-btn btn btn-outline-dark" onClick={e => logout()}>{t("Logout")}</button>
              </div>
              :
              <div>
                <span className="greeting_txt"></span>
                <span role="application" aria-roledescription={t("Greeting")} aria-label={thisAccountCustomer ? (t("Hello") + " " + thisAccountCustomer.customerFirstName + " " + thisAccountCustomer.customerLastName + ",") : ""}>{thisAccountCustomer ? (t("Hello") + " " + thisAccountCustomer.customerFirstName + " " + thisAccountCustomer.customerLastName + ",") : null}</span> <span aria-label={t("Logout")} role="button" className="logout" onClick={e => logout()}>{t("Logout")}</span>
              </div>
            }



            <div className="side-menu-wrap">
              {renderMenuItems()}
            </div>

          </Col>

          {/* Sections */}
          <Col>
            <UserPersonalDetailsForm
                  t={t}
                  register={register}
                  submitForm={submitForm}
                  handleSubmit={handleSubmit}
                  errors={errors}
                  errorMessage={errorMessage}
            />

            <div id="ordersTab" className="account-section ">
              <OrdersTable
                thisAccountCustomer={thisAccountCustomer}
                chainId={chainId}
                isCompanyUser={isCompanyUser}
              />
            </div>
            
            <div id="contactformTab" className="account-section hidden">
              <h4 id="contact-title">{t("ContactForm")}</h4>
              <form onSubmit={handleSubmitContact((data) => submitContactForm(data))} aria-labelledby="contact-title">
                <div className="personal-details-form-wrap box">
                  <div >
                    <Row>
                      <Col xs="12" md="6">
                        <label htmlFor="fullNameContactInput" htmlFor="fullNameContactInput"> {t("FullName")}</label>
                        <input
                          id="fullNameContactInput"
                          name="fullNameContactInput"
                          {...registerContact("fullNameContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("FullNameRegex")),
                              message: t("FullNameRegexMsg"),
                            },
                          })}

                        />
                        <span className="error">{errorsContact.fullNameContactInput?.message}</span>
                      </Col>
                      <Col xs="12" md="6">
                        <label htmlFor="PhoneContactInput" htmlFor="PhoneContactInput"> {t("Phone")}</label>
                        <input
                          id="PhoneContactInput"
                          name="PhoneContactInput"
                          {...registerContact("PhoneContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("PhoneRegex")),
                              message: t("PhoneRegexMsg"),
                            },
                          })}

                        />
                        <span className="error">{errorsContact.PhoneContactInput?.message}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" md="6">
                        <label htmlFor="EmailContactInput"> {t("Email")}</label>
                        <input
                          id="EmailContactInput"
                          name="EmailContactInput"
                          {...registerContact("EmailContactInput", {
                            required: t("Required"),
                            pattern: {
                              value: new RegExp(t("EmailRegex")),
                              message: t("EmailRegexMsg"),
                            },
                          })}

                        />
                        <span className="error">{errorsContact.EmailContactInput?.message}</span>
                      </Col>
                      <Col xs="12" md="6">

                        <Row>
                          <Col sm={12} md={6}><label htmlFor="MessageContactInput"> {t("ContactMessage")}</label>    </Col>
                          <Col sm={12} md={6} className="botom-inputs">
                            <div className="words-counter">
                              <span className="delete" onClick={e => clearText('MessageContactInput')}>{t("Delete")}</span>
                              <span id={"counter"}>0/{TextAreaMaxLength}</span>

                            </div>
                          </Col>
                        </Row>
                        <textarea className="text-area"
                          id={'MessageContactInput'}
                          onKeyUp={e => textCounter('MessageContactInput', 'counter', TextAreaMaxLength)}
                          name="MessageContactInput"
                          {...registerContact("MessageContactInput", { maxLength: TextAreaMaxLength }, {
                            required: t("Required"),

                          })} rows="4" ></textarea>
                        <span className="error">{errorsContact.MessageContactInput?.message}</span>
                      </Col>

                    </Row>
                    <Row>
                      <Col xs="12" md="6">
                        <input
                          type="submit"
                          className="btn"
                          value={t("Send")}
                        />
                      </Col>
                    </Row>


                  </div>
                </div>
              </form>
              {!company &&
                <CustomerReqTableComponent message={t("YourRequests")} allCustomerRequests={allCustomerRequests} ></CustomerReqTableComponent>
              }


            </div>

              {
                /* company only sections */
                company &&
                
                <>
                  <CompanyDetailsForm />
                  <div id="workersTab" className="account-section hidden">
                    <CompanyWorkersTable />
                  </div>
                  <div id="greetingsTab" className="account-section hidden">
                    <CompanyGreetingsTable />
                  </div>
                </>
                
              }


          </Col>
          
        </Row>

        {/* Toast messages for my account */}
        <Snackbar
          open={toasts.length > 0}
          autoHideDuration={4000}
          onClose={() => dispatch(hideToast())}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          style={{ position: "absolute" }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {toasts.map((toast) => (
              <ToastItem key={toast.id} toast={toast} onDismiss={(id) => dispatch(hideToast(id))} />
            ))}
          </div>
        </Snackbar>
      </div>
    </>
  );

}

export default MyAccountComponent;